import React, { useEffect, useState } from "react";
import { fetchWorkingDays } from "../Api/WorkingDays";
import { getAllHouseBanks } from "../Api/HouseBank";
import { getAllBankStatements } from "../Api/BankStatements";
import { Form, Button, Table } from "react-bootstrap";
import { getReconciliationData } from "../Api/Reconciliation";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { GrGroup } from "react-icons/gr";
import { IoMdCash } from "react-icons/io";
import { FaPersonArrowDownToLine } from "react-icons/fa6";
import { useAuth } from "../Context/AuthContext";
const ManualBankReconciliation = () => {
  const { monthId, houseBankId } = useParams();

  const [workingDays, setWorkingDays] = useState([]);
  const [houseBanks, setHouseBanks] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedHouseBank, setSelectedHouseBank] = useState("");
  const [bankStatements, setBankStatements] = useState([]);
  const [selectedRows, setSelectedRows] = useState({});
  const [selectedStatement, setSelectedStatement] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const{user}=useAuth();

  useEffect(() => {
    loadWorkingDays();
    loadHouseBanks();
  }, []);

  // Effect to set initial values from URL params
  useEffect(() => {
    if (monthId) setSelectedMonth(monthId);
    if (houseBankId) setSelectedHouseBank(houseBankId);
  }, [monthId, houseBankId]);

  // Effect to automatically load bank statements when both values are available
  useEffect(() => {
    if (selectedMonth && selectedHouseBank) {
      loadBankStatements();
    }
  }, [selectedMonth, selectedHouseBank]); // This will trigger when either changes and both are available
  console.log(selectedMonth)
  const loadWorkingDays = async () => {
    try {
      const response = await fetchWorkingDays(user?.organisationId);
      const filtered = (response || []).filter(
        (day) => day.reconciliationStatus === "0"
      );
      setWorkingDays(filtered);
    } catch (error) {
      console.error("Error fetching working days:", error);
    }
  };

  const loadHouseBanks = async () => {
    try {
      const response = await getAllHouseBanks(user?.organisationId);
      // const filteredBanks = (response || []).filter(
      //   (bank) => bank.companycode !== null && bank.companycode !== ""
      // );
      setHouseBanks(response);
    } catch (error) {
      console.error("Error fetching house banks:", error);
    }
  };

  const loadBankStatements = async () => {
    if (!selectedMonth || !selectedHouseBank) return;

    setIsLoading(true);
    try {
      const statements = await getAllBankStatements(selectedMonth);
      if(statements.length===0)
        setBankStatements([]);
      else
      {
        const filteredStatements = (statements || []).filter(
        (stmt) => stmt.housebankId === selectedHouseBank
      );
      setBankStatements(filteredStatements);}

      // const reconciliationData = await getReconciliationData();

      // const unmatchedStatements = filteredStatements.filter((stmt) => {
      //   return !reconciliationData.some(
      //     (reco) =>
      //       reco.statementId === stmt.statementId &&
      //       Number(reco.recoAmount) === Number(stmt.transactionAmount)
      //   );
      // });

    
    } catch (error) {
      console.error(
        "Error fetching bank statements or reconciliation data:",
        error
      );
      setBankStatements([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await loadBankStatements();
  };

  const toggleRowSelection = (statementId) => {
    setSelectedRows((prev) => ({
      ...prev,
      [statementId]: !prev[statementId],
    }));

    // Set the selected statement when a row is selected
    if (!selectedRows[statementId]) {
      const selected = bankStatements.find(
        (stmt) => stmt.statementId === statementId
      );
      setSelectedStatement(selected);
    } else {
      setSelectedStatement(null);
    }
  };
const handlePostDocument = (stmt) => {
  navigate(
    `/post-document/${selectedMonth}/${selectedHouseBank}`,
    { state: { statement: stmt } }
  );
};

  const handleAction = (statementId, action) => {
    const selected = bankStatements.find(
      (stmt) => stmt.statementId === statementId
    );
    if (!selected) return;

    switch (action) {
      case "STPL Transfer":
        navigate(
          `/StplTransferReconciliation/${selectedMonth}/${selectedHouseBank}`,
          {
            state: { statement: selected },
          }
        );
        break;
      case "Payment":
        navigate(
          `/PaymentReconciliation/${selectedMonth}/${selectedHouseBank}`,
          { state: { statement: selected } }
        );
        break;
      case "Personal":
        navigate(
          `/PersonalReconciliation/${selectedMonth}/${selectedHouseBank}`,
          { state: { statement: selected } }
        );
        break;
      default:
        break;
    }
  };

  return (
    <div className="container mt-4">
      <h4>Manual Bank Reconciliation</h4>
      <Form onSubmit={handleSubmit}>
        <Form.Group controlId="monthSelect" className="mb-3">
          <Form.Label>Month</Form.Label>
          <Form.Select
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(e.target.value)}
            required
          >
            <option value="">Select Month</option>
            {workingDays.map((day) => (
              <option key={day.workingDaysId} value={day.workingDaysId}>
                {`${day.workingMonth}-${day.workingYear}`}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        <Form.Group controlId="houseBankSelect" className="mb-3">
          <Form.Label>House Bank</Form.Label>
          <Form.Select
            value={selectedHouseBank}
            onChange={(e) => setSelectedHouseBank(e.target.value)}
            required
          >
            <option value="">Select House Bank</option>
            {houseBanks.map((bank) => (
              <option key={bank.housebankId} value={bank.housebankId}>
                {bank.housebankId} - {bank.bankName} - {bank.accountNumber}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        <Button type="submit" variant="primary" disabled={isLoading}>
          {isLoading ? "Loading..." : "Load Bank Statements"}
        </Button>
      </Form>

      {isLoading && (
        <div className="mt-4 text-center">
          <p>Loading bank statements...</p>
        </div>
      )}

      {!isLoading && bankStatements.length > 0 && (
        <div className="mt-4">
          <h5>Bank Statements</h5>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>#</th>
                <th>House Bank ID</th>
                <th>Transaction ID</th>
                <th>Narration</th>
                <th>Statement ID</th>
                <th>Bank Name</th>
                <th>Account Number</th>
                <th>Transaction Date</th>
                <th>Amount</th>
                <th>Credit/Debit</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {bankStatements.map((stmt, index) => (
                <tr key={stmt.statementId}>
                  <td>{index + 1}</td>
                  <td>{stmt.housebankId}</td>
                  <td>{stmt.transactionId}</td>
                  <td>{stmt.narration}</td>
                  <td>{stmt.statementId}</td>
                  <td>{stmt.bankName}</td>
                  <td>{stmt.accountNumber}</td>
                  <td>
                    {new Date(stmt.valueDate).toLocaleDateString()}
                  </td>
                  <td>{stmt.transactionAmount}</td>
                  <td>{stmt.creditDebit}</td>
                  <td>
                    <Button
                      variant="info"
                      size="sm"
                      className="me-2"
                      title="Self transfer"
                      onClick={() =>
                        handleAction(stmt.statementId, "STPL Transfer")
                      }
                    >
                      <GrGroup />
                    </Button>
                    <Button
                      variant="success"
                      size="sm"
                      className="me-2"
                      onClick={() => handleAction(stmt.statementId, "Payment")}
                    >
                      <IoMdCash />
                    </Button>
                    <Button
                      variant="warning"
                      size="sm"
                      title="Personal Reconcilation"
                      onClick={() => handleAction(stmt.statementId, "Personal")}
                    >
                      <FaPersonArrowDownToLine />
                    </Button>
                    <Button
                    variant="danger"
                    size="sm"
                    className="me-2"
                    title="Post Document"
                    onClick={() => handlePostDocument(stmt)}
                  >
                    <IoMdCash />
                  </Button>

                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}

      {!isLoading &&
        bankStatements.length === 0 &&
        selectedHouseBank &&
        selectedMonth && (
          <p className="mt-4 text-muted">
            No statements found for this house bank.
          </p>
        )}
    </div>
  );
};

export default ManualBankReconciliation;

// import React, { useEffect, useState } from "react";
// import { fetchWorkingDays } from "../Api/WorkingDays";
// import { getAllHouseBanks } from "../Api/HouseBank";
// import { getAllBankStatements } from "../Api/BankStatements";
// import { Form, Button, Table } from "react-bootstrap";
// import { getReconciliationData } from "../Api/Reconciliation";
// import { useNavigate } from "react-router-dom";
// import { useParams } from "react-router-dom";
// import { GrGroup } from "react-icons/gr";
// import { IoMdCash } from "react-icons/io";
// import { FaPersonArrowDownToLine } from "react-icons/fa6";

// const ManualBankReconciliation = () => {
//   const { monthId, houseBankId } = useParams();

//   useEffect(() => {
//     if (monthId) setSelectedMonth(monthId);
//     if (houseBankId) setSelectedHouseBank(houseBankId);
//   }, [monthId, houseBankId]);

//   const [workingDays, setWorkingDays] = useState([]);
//   const [houseBanks, setHouseBanks] = useState([]);
//   const [selectedMonth, setSelectedMonth] = useState("");
//   const [selectedHouseBank, setSelectedHouseBank] = useState("");
//   const [bankStatements, setBankStatements] = useState([]);
//   const [selectedRows, setSelectedRows] = useState({});
//   const [selectedStatement, setSelectedStatement] = useState(null);
//   const navigate = useNavigate();

//   useEffect(() => {
//     loadWorkingDays();
//     loadHouseBanks();
//   }, []);

//   const loadWorkingDays = async () => {
//     try {
//       const response = await fetchWorkingDays();
//       const filtered = (response || []).filter(
//         (day) => day.reconciliationStatus === "0"
//       );
//       setWorkingDays(filtered);
//     } catch (error) {
//       console.error("Error fetching working days:", error);
//     }
//   };

//   const loadHouseBanks = async () => {
//     try {
//       const response = await getAllHouseBanks();
//       const filteredBanks = (response || []).filter(
//         (bank) => bank.companycode !== null && bank.companycode !== ""
//       );
//       setHouseBanks(filteredBanks);
//     } catch (error) {
//       console.error("Error fetching house banks:", error);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const statements = await getAllBankStatements();
//       const filteredStatements = (statements || []).filter(
//         (stmt) => stmt.housebankId === selectedHouseBank
//       );

//       const reconciliationData = await getReconciliationData();

//       const unmatchedStatements = filteredStatements.filter((stmt) => {
//         return !reconciliationData.some(
//           (reco) =>
//             reco.statementId === stmt.statementId &&
//             Number(reco.recoAmount) === Number(stmt.transactionAmount)
//         );
//       });

//       setBankStatements(unmatchedStatements);
//     } catch (error) {
//       console.error(
//         "Error fetching bank statements or reconciliation data:",
//         error
//       );
//     }
//   };

//   const toggleRowSelection = (statementId) => {
//     setSelectedRows((prev) => ({
//       ...prev,
//       [statementId]: !prev[statementId],
//     }));

//     // Set the selected statement when a row is selected
//     if (!selectedRows[statementId]) {
//       const selected = bankStatements.find(
//         (stmt) => stmt.statementId === statementId
//       );
//       setSelectedStatement(selected);
//     } else {
//       setSelectedStatement(null);
//     }
//   };

//   const handleAction = (statementId, action) => {
//     const selected = bankStatements.find(
//       (stmt) => stmt.statementId === statementId
//     );
//     if (!selected) return;

//     switch (action) {
//       case "STPL Transfer":
//         navigate(
//           `/StplTransferReconciliation/${selectedMonth}/${selectedHouseBank}`,
//           {
//             state: { statement: selected },
//           }
//         );
//         break;
//       case "Payment":
//         navigate(
//           `/PaymentReconciliation/${selectedMonth}/${selectedHouseBank}`,
//           { state: { statement: selected } }
//         );
//         break;
//       case "Personal":
//         navigate(
//           `/PersonalReconciliation/${selectedMonth}/${selectedHouseBank}`,
//           { state: { statement: selected } }
//         );
//         break;
//       default:
//         break;
//     }
//   };

//   return (
//     <div className="container mt-4">
//       <h4>Manual Bank Reconciliation</h4>
//       <Form onSubmit={handleSubmit}>
//         <Form.Group controlId="monthSelect" className="mb-3">
//           <Form.Label>Month</Form.Label>
//           <Form.Select
//             value={selectedMonth}
//             onChange={(e) => setSelectedMonth(e.target.value)}
//             required
//           >
//             <option value="">Select Month</option>
//             {workingDays.map((day) => (
//               <option key={day.workingDaysId} value={day.workingDaysId}>
//                 {`${day.workingMonth}-${day.workingYear}`}
//               </option>
//             ))}
//           </Form.Select>
//         </Form.Group>

//         <Form.Group controlId="houseBankSelect" className="mb-3">
//           <Form.Label>House Bank</Form.Label>
//           <Form.Select
//             value={selectedHouseBank}
//             onChange={(e) => setSelectedHouseBank(e.target.value)}
//             required
//           >
//             <option value="">Select House Bank</option>
//             {houseBanks.map((bank) => (
//               <option key={bank.housebankId} value={bank.housebankId}>
//                 {bank.housebankId} - {bank.bankName} - {bank.accountNumber}
//               </option>
//             ))}
//           </Form.Select>
//         </Form.Group>

//         <Button type="submit" variant="primary">
//           Load Bank Statements
//         </Button>
//       </Form>

//       {bankStatements.length > 0 && (
//         <div className="mt-4">
//           <h5>Bank Statements</h5>
//           <Table striped bordered hover>
//             <thead>
//               <tr>
//                 {/* <th></th> */}
//                 <th>#</th>
//                 <th>House Bank ID</th>
//                 <th>Transaction ID</th>
//                 <th>Narration</th>
//                 <th>Statement ID</th>
//                 <th>Bank Name</th>
//                 <th>Account Number</th>
//                 <th>Transaction Date</th>
//                 <th>Amount</th>
//                 <th>Credit/Debit</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {bankStatements.map((stmt, index) => (
//                 <tr key={stmt.statementId}>
//                   {/* <td>
//                     <Form.Check
//                       type="checkbox"
//                       checked={!!selectedRows[stmt.statementId]}
//                       onChange={() => toggleRowSelection(stmt.statementId)}
//                     />
//                   </td> */}
//                   <td>{index + 1}</td>
//                   <td>{stmt.housebankId}</td>
//                   <td>{stmt.transactionId}</td>
//                   <td>{stmt.narration}</td>
//                   <td>{stmt.statementId}</td>
//                   <td>{stmt.bankName}</td>
//                   <td>{stmt.accountNumber}</td>
//                   <td>
//                     {new Date(stmt.transactionPostedDate).toLocaleDateString()}
//                   </td>
//                   <td>{stmt.transactionAmount}</td>
//                   <td>{stmt.creditDebit}</td>
//                   <td>
//                     <Button
//                       variant="info"
//                       size="sm"
//                       className="me-2"
//                       // disabled={!selectedRows[stmt.statementId]}
//                       onClick={() =>
//                         handleAction(stmt.statementId, "STPL Transfer")
//                       }
//                     >
//                       {/* StplTransferReconciliation */}
//                       <GrGroup />
//                     </Button>
//                     <Button
//                       variant="success"
//                       size="sm"
//                       className="me-2"
//                       // disabled={!selectedRows[stmt.statementId]}
//                       onClick={() => handleAction(stmt.statementId, "Payment")}
//                     >
//                       {/* PaymentReconciliation */}
//                       <IoMdCash />
//                     </Button>
//                     <Button
//                       variant="warning"
//                       size="sm"
//                       // disabled={!selectedRows[stmt.statementId]}
//                       onClick={() => handleAction(stmt.statementId, "Personal")}
//                     >
//                       {/* personalReconciliation */}
//                       <FaPersonArrowDownToLine />
//                     </Button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </Table>
//         </div>
//       )}

//       {bankStatements.length === 0 && selectedHouseBank && (
//         <p className="mt-4 text-muted">
//           No statements found for this house bank.
//         </p>
//       )}
//     </div>
//   );
// };

// export default ManualBankReconciliation;
